import controller from './sensor-details.controller';

const template = require('./sensor-details.html');

export default {
    bindings: {
        thing: '<sensor',
        thingUpdate: '<',
        onThingUpdated: '&',
        onMoveSensor: '&',
        onAddSensorToDashboard: '&'
    },
    template,
    controller
};
